import React from 'react'
import { Typography, Paper } from '@mui/material'
import { ErrorBoundary } from 'components'
import { LoadingStudentsReport } from 'pages/reports/students-report'

export function ViewStudentsReport({ resource, ..._props }) {
  const {
    data = {},
    isLoading = false,
    isFetching = false,
    isPending = false,
    error,
    isError,
    status,
  } = resource

  if (isPending) return <LoadingStudentsReport />

  if (isError) {
    return (
      <ErrorBoundary>
        <Typography variant="h3" color="error">
          {error.message}
        </Typography>
      </ErrorBoundary>
    )
  }

  return (
    <>
      <ErrorBoundary fallback={<div>Error</div>}>
        <div className="grid lg:grid-cols-3 md:grid-cols-2 grid-cols-1 gap-8 uppercase py-12">
          <Paper className="p-4 shadow-md flex flex-col justify-around items-stretch h-32">
            <Typography variant="h2" component="p" align="center">
              {data?.notReadyForApproval}
            </Typography>
            <Typography variant="h6" component="p" align="center">
              No estan listos para validar su identidad
            </Typography>
          </Paper>
          <Paper className="p-4 shadow-md flex flex-col justify-around items-stretch h-32">
            <Typography variant="h2" component="p" align="center">
              {data?.pendingApproval}
            </Typography>
            <Typography variant="h6" component="p" align="center">
              PENDIENTES DE VALIDACIÓN DE IDENTIDAD
            </Typography>
          </Paper>
          <Paper className="p-4 shadow-md flex flex-col justify-around items-stretch h-32">
            <Typography variant="h2" component="p" align="center">
              {data?.approved}
            </Typography>
            <Typography variant="h6" component="p" align="center">
              IDENTIDAD VALIDADA
            </Typography>
          </Paper>
          <Paper className="p-4 shadow-md flex flex-col justify-around items-stretch h-32">
            <Typography variant="h2" component="p" align="center">
              {data?.rejected}
            </Typography>
            <Typography variant="h6" component="p" align="center">
              IDENTIDAD RECHAZADA (PENDIENTES DE SER CONTACTADOS)
            </Typography>
          </Paper>
          <Paper className="p-4 shadow-md flex flex-col justify-around items-stretch h-32">
            <Typography variant="h2" component="p" align="center">
              {data?.notAccreditted}
            </Typography>
            <Typography variant="h6" component="p" align="center">
              NO RECIBIERON ACREDITACIÓN ALGUNA
            </Typography>
          </Paper>
          <Paper className="p-4 shadow-md flex flex-col justify-around items-stretch h-32">
            <Typography variant="h2" component="p" align="center">
              {data?.partialAccreditation}
            </Typography>
            <Typography variant="h6" component="p" align="center">
              CON ACREDITACIÓN PARCIAL
            </Typography>
          </Paper>
        </div>
        <Paper className="p-4 shadow-md flex flex-col justify-around items-stretch h-32 bg-success text-white">
          <Typography
            variant="h2"
            component="p"
            align="center"
            className="text-white"
          >
            {data?.totalAccreditation}
          </Typography>
          <Typography variant="h6" component="p" align="center">
            ACREDITACIÓN TOTAL
          </Typography>
        </Paper>
      </ErrorBoundary>
    </>
  )
}
